{
  "name": "Ad Command Center",
  "slug": "ad-command-center",
  "icon": "megaphone",
  "description": "Request, review, and publish paid ad campaigns across Meta and LinkedIn",
  "owner": "Andre",
  "team": "Marketing",
  "tables": {
    "own": ["ad_command_center_"]
  }
}
